import api from './api'
import { stringify } from 'querystring'

const url = 'payslips'

export const getPayslipByDate = (monthAndYear) => api.get(`${url}?${stringify(monthAndYear)}`, { responseType: 'arraybuffer', timeout: 60000 })